const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// The typed words, highlighted wherever they appear.
export function Highlight({ text, q }) {
  if (!text) return null;
  if (!q) return text;
  const parts = String(text).split(new RegExp(`(${escape(q)})`, 'ig'));
  return parts.map((p, i) => (p.toLowerCase() === q.toLowerCase()
    ? <mark key={i} className="bg-[#C4A561]/25 text-inherit rounded-[2px] px-[1px]">{p}</mark>
    : <span key={i}>{p}</span>));
}

// One match: title, muted details, a status badge. Never any money figures.
export default function HeaderSearchRow({ row, q, active, onPick, onHover, id, testid }) {
  const sub = (row.sub || []).filter(Boolean);
  return (
    <li id={id} role="option" aria-selected={active} data-testid={testid}
      onMouseDown={(e) => e.preventDefault()} onClick={onPick} onMouseEnter={onHover}
      className={`flex items-start justify-between gap-3 px-3 py-2 cursor-pointer transition-colors ${active ? 'bg-[#4575A8]/10' : ''}`}>
      <div className="min-w-0">
        <div className="text-xs font-semibold truncate" style={{ color: 'var(--strata-text-primary)' }}><Highlight text={row.title} q={q} /></div>
        {sub.length > 0 && (
          <div className="text-[11px] truncate mt-0.5" style={{ color: 'var(--strata-text-muted)' }}>
            {sub.map((s, i) => <span key={i}>{i > 0 && ' · '}<Highlight text={s} q={q} /></span>)}
          </div>
        )}
      </div>
      {row.badge && <span className={`shrink-0 text-[9px] px-1.5 py-0.5 rounded font-medium uppercase tracking-wider ${row.tone || ''}`}>{row.badge}</span>}
    </li>
  );
}
